const tvMonitor = {
    'document_title': 'Real-time Monitoring',
    'to_fullscreen': 'Switch to Fullscreen'
};

export default tvMonitor;
